export default "__VITE_ASSET__d1d6d2d0__"